/** Absence is unclassified; only an explicit automation fact (desktop or browser harness launch, runner send) sets it. */
export const IRIS_AUTOMATION_PROPERTY = 'iris_automation';

/** Apply launch classification last so caller or persisted properties cannot override it. */
export function applyDesktopAutomationProperties(
  properties: Record<string, unknown>,
  automated: boolean
): Record<string, unknown> {
  const result = { ...properties };
  // Normal launches must also remove a marker inherited from an older test profile.
  delete result[IRIS_AUTOMATION_PROPERTY];
  if (automated) result[IRIS_AUTOMATION_PROPERTY] = true;
  return result;
}
